export type Language = {
  code: string
  name: string
}

export const languages: Language[] = [
  // Engelska (Default)
  { code: "en-US", name: "English (United States)" },

  // Nordic languages
  { code: "sv-SE", name: "Swedish (Sweden)" },
  { code: "nb-NO", name: "Norwegian (Bokmål)" },
  { code: "da-DK", name: "Danish (Denmark)" },
  { code: "fi-FI", name: "Finnish (Finland)" },

  // Other languages
  { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
  { code: "zh-Hans", name: "Chinese (Simplified)" },
  { code: "de-DE", name: "German (Germany)" },
  { code: "fr-FR", name: "French (France)" },
  { code: "hi-IN", name: "Hindi (India)" },
  { code: "id-ID", name: "Indonesian" },
  { code: "pt-BR", name: "Portuguese (Brazil)" },
  { code: "ru-RU", name: "Russian" },
  { code: "es-ES", name: "Spanish (Spain)" },
]
